import type { ExpressCheckoutPartialAddress } from '@stripe/stripe-js'
import { logger } from 'services/logger'
import { useCartStore } from 'stores/cartStore/CartStoreProvider'
import { usePhotoBooksStore, useTilesStore } from 'stores/RootStoreProvider'
import { useAvailableFrames } from 'components/FrameProvider/AvailableStockProvider'
import { createPartialAddressFromStripeFormat } from 'components/StripeAddressForm/stripeAdapter'
import { getUnsupportedBagProduct } from 'components/Checkout/unsupportedProductValidation'

export function useExpressCheckoutDestinationChecker() {
  const cart = useCartStore()
  const tilesStore = useTilesStore()
  const photoBooksStore = usePhotoBooksStore()
  const { getLocalSKUsByAddress } = useAvailableFrames()

  return async (stripeAddress: ExpressCheckoutPartialAddress) => {
    const { countryId, ...partialAddress } =
      createPartialAddressFromStripeFormat(stripeAddress)
    if (!countryId) {
      throw new Error(
        `Express checkout address has an unknown country: ${stripeAddress.country}`
      )
    }
    const address = { ...partialAddress, countryId }
    const localSKUs = await getLocalSKUsByAddress({ address }).catch(
      (error) => {
        logger.error('Express checkout stock lookup failed', error)
        return null
      }
    )
    return (
      getUnsupportedBagProduct({
        cart,
        photoBooksStore,
        tilesStore,
        address,
        localSKUs,
      }) === null
    )
  }
}
